import React from 'react';
import { Modal } from '../../components/ui';
import { isWeddingFunction, MAX_NAME } from '../../utils/helpers';

// Mobile add / edit sheet (phone browsers and the APK): full screen, the
// functions as full-width tap rows, the main action fills the footer.
// Logic: useGuestHome.
export default function GuestFormMobile({ vm }) {
  const { editing, form, formErr, saving, addedCount, pickerFunctions, closeForm, setField, toggleFunction, save } = vm;

  return (
    <Modal fullScreen title={editing ? 'Edit guest' : 'Add a guest'} onClose={closeForm}
      footer={(
        <>
          <button type="button" className={'btn ' + (editing ? 'primary pp-grow' : 'light')} onClick={() => (editing ? save() : closeForm())} disabled={saving}>
            {editing ? (saving ? 'Saving…' : 'Save') : 'Done'}
          </button>
          {!editing && (
            <button type="button" className="btn primary pp-grow" onClick={() => save({ addNext: true })} disabled={saving}>
              {saving ? 'Saving…' : 'Save & add next'}
            </button>
          )}
        </>
      )}>
      {!editing && addedCount > 0 && <div className="chip ok" style={{ marginBottom: 10 }}>{addedCount} added</div>}
      <div className="pp-row" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <label className="field">Surname
          <input value={form.Surname} maxLength={MAX_NAME} onChange={e => setField('Surname', e.target.value)} />
        </label>
        <label className="field">Name *
          <input value={form.GuestName} maxLength={MAX_NAME} onChange={e => setField('GuestName', e.target.value)} />
        </label>
      </div>
      <label className="field">Mobile (optional)
        <input type="tel" inputMode="numeric" value={form.MobileNumber} placeholder="10 digits"
          onChange={e => setField('MobileNumber', e.target.value)} />
      </label>
      <div className="field-label">Invite to *</div>
      <div className="pp-taps">
        {pickerFunctions.map(f => {
          const on = form.FunctionIds.includes(String(f.FunctionId));
          return (
            <button key={f.FunctionId} type="button" className={'pp-tap' + (on ? ' on' : '')} aria-pressed={on}
              onClick={() => toggleFunction(f.FunctionId)}>
              <span className="pp-tap-box">{on ? '✓' : ''}</span>
              {isWeddingFunction(f) ? '💍 ' : ''}{f.FunctionName}
            </button>
          );
        })}
      </div>
      {formErr && <div className="guest-form-err">⚠ {formErr}</div>}
    </Modal>
  );
}
